import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(res.data);
        window.history.replaceState(null, "", "/studio");
        navigate("/studio", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0D1117] text-[#F0F6FC]">
      <Loader2 className="w-8 h-8 animate-spin text-[#38BDF8]" />
      <p className="mt-4 text-sm text-[#8B949E] font-mono-cad">Establishing secure session…</p>
    </div>
  );
}
